import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PassholdersWatchlistService {

  constructor(private http: HttpClient) { }

  getPassholdersWatchlist(eventType: any): Observable<any> {
    const url = environment.apiURL + `api/passholders-watchlist`;
    let queryParams = new HttpParams();

    if (eventType && eventType !== 'ALL') { 
      queryParams = queryParams.append("eventType", eventType);
    }
    return this.http.get(url,{params:queryParams});
  }
        
  delete(eventId: any, userId: any, eventType: any): Observable<any> {
    const url = environment.apiURL + `api/passholders-watchlist`;
    let params = new HttpParams();
    params = params.append('userId', userId);
    params = params.append('eventId', eventId);
    params = params.append('eventType', eventType);
    return this.http.delete(url, { params: params , responseType: 'text' });
  }

  UpdatePassholderWatchlist(eventId: any, isMustSee: any, eventType: any): Observable<any> {
    const url = environment.apiURL + `api/passholders-watchlist/${eventId}`;
  
    const formData = new FormData();
    formData.append('eventId', eventId);
  
    let params: HttpParams = new HttpParams();
    params = params.set('eventType', eventType);
    params = params.set('isMustSee', isMustSee);
    return this.http.post(url, formData, {
      params: params
    });
  }
}
